import { ArrowLeft } from 'lucide-react';

export default function StockBreadcrumb({ sym, onBack }) {
  return (
    <div className="stock-breadcrumb">
      <div className="bc-back" onClick={onBack}>
        <ArrowLeft size={13} /> Daily Brief
      </div>
      <span className="bc-sep">/</span>
      <span className="bc-sym">{sym}</span>
    </div>
  );
}
